import { Box, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import { DocTopBar } from "./DocTopBar";
import ErrorBoundary from "../helpers/ErrorBoundary";

/** Visite d’une fiche doc /docs/:id (pas /docs/new). */
function isDocViewerPath(pathname: string) {
  return /^\/docs\/(?!new$)[^/]+$/.test(pathname);
}

export function DocAppPage({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const s = theme.palette.saas;
  const { pathname } = useLocation();
  const fullWidthDoc = isDocViewerPath(pathname);
  return (
    <Box sx={{ bgcolor: s.pageBg, minHeight: "100vh" }}>
      <DocTopBar />
      <Box
        component="main"
        sx={{
          flex: 1,
          p: 2,
          maxWidth: fullWidthDoc ? "min(98vw, 100%)" : 1280,
          width: fullWidthDoc ? "100%" : undefined,
          boxSizing: "border-box",
          mx: "auto",
        }}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </Box>
    </Box>
  );
}
